import React from 'react';
import styled from 'styled-components';

type Props = {
  children?: React.ReactNode,
};
const Tab = ({children}: Props) => <StatusLink>{children}</StatusLink>;

export default Tab;

const StatusLink = styled.ul`
  display: flex;
  border-bottom: 1px solid #eeeeee;
  text-align: left;

  a {
    margin-right: 25px;
    padding: 10px 0;
    display: block;
    font-size: 14px;
    color: #8e8e8e;
  }

  span {
    font-size: 12px;
    margin-left: 5px;
  }
`;
